<template>
  <el-form-item label="显示标题">
    <el-switch v-model="prop.showRightAxisName" @change="closeYName()" size="small">
    </el-switch>
  </el-form-item>
  <el-form-item label="标题" v-if="prop.showRightAxisName">
    <el-input v-model="prop.rightAxisName" size="small"></el-input>
  </el-form-item>
  <el-form-item label="标题字体">
    <el-select v-model="prop.rightAxisNameFontFamily" size="small">
      <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
      <el-option label="宋体" value="SimSun"></el-option>
      <el-option label="黑体" value="SimHei"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="标题字号">
    <el-input-number v-model="prop.rightAxisNameFontSize" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="标题字色">
    <colorPicker v-model="prop.rightAxisNameColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示轴标签">
    <el-switch v-model="prop.rightAxisLabelShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="轴标签字体">
    <el-select v-model="prop.rightAxisFontFamily" size="small">
      <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
      <el-option label="宋体" value="SimSun"></el-option>
      <el-option label="黑体" value="SimHei"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="轴标签旋转">
    <el-input-number v-model="prop.rightAxisRotate" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="轴标签字号">
    <el-input-number v-model="prop.rightAxisFontSize" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="轴标签字色">
    <colorPicker v-model="prop.rightAxisColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示轴线">
    <el-switch v-model="prop.rightAxisLineShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="轴线粗细">
    <el-input-number v-model="prop.rightAxisLineWidth" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="轴线颜色">
    <colorPicker v-model="prop.rightAxisLineColor"></colorPicker>
  </el-form-item>
  <el-form-item label="共用指标轴">
    <el-switch v-model="prop.sameyAxis" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="最小数值">
    <div class="checkboxAndNumber">
      <el-checkbox v-model="prop.rightAxisMinAuto" label="自动"/>
      <div style="width: 16px;"></div>
      <el-input-number v-model="prop.rightAxisMin" size="small" controls-position="right"></el-input-number>
    </div>
  </el-form-item>
  <el-form-item label="最大数值">
    <div class="checkboxAndNumber">
      <el-checkbox v-model="prop.rightAxisMaxAuto" label="自动"/>
      <div style="width: 16px;"></div>
      <el-input-number v-model="prop.rightAxisMax" size="small" controls-position="right"></el-input-number>
    </div>
  </el-form-item>
  <el-form-item label="数值间距">
    <div class="checkboxAndNumber">
      <el-checkbox v-model="prop.rightAxisIntervalAuto" label="自动"/>
      <div style="width: 16px;"></div>
      <el-input-number v-model="prop.rightAxisInterval" :min="0" size="small"
                       controls-position="right"></el-input-number>
    </div>
  </el-form-item>
  <el-form-item label="最小间距">
    <el-input-number v-model="prop.rightAxisminInterval" :min="0" size="small"
                     controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="显示">
    <el-switch v-model="prop.rightAxisShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="显示网格线">
    <el-switch v-model="prop.rightAxisSplitLineShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="开启网格虚线">
    <el-switch v-model="prop.rightAxisSplitLineShowDotted" size="small">
    </el-switch>
  </el-form-item>
  <el-form-item label="网格线粗细">
    <el-input-number v-model="prop.rightAxisSplitLineWidth" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="网格线颜色">
    <colorPicker v-model="prop.rightAxisSplitLineColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示参考线">
    <el-switch v-model="prop.rightAxisMarkLineShow" size="small"></el-switch>
  </el-form-item>
  <template v-if="prop.rightAxisMarkLineShow">
    <el-form-item label="参考线线型">
      <el-select v-model="prop.rightAxisMarkLineType" size="small">
        <el-option label="实线" value="solid"></el-option>
        <el-option label="虚线" value="dashed"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="参考线粗细">
      <el-input-number v-model="prop.rightAxisMarkLineWidth" size="small" controls-position="right"></el-input-number>
    </el-form-item>
    <el-form-item label="参考线颜色">
      <colorPicker v-model="prop.rightAxisMarkLineColor"></colorPicker>
    </el-form-item>
    <el-form-item label="参考线">
      <el-link @click="openReference" type="primary" class="fs-16" :icon="Edit"></el-link>
    </el-form-item>
    <div class="pl-20 pr-20">
      <el-table :data="main.activeOption?.['rightReferenceCustomSet'] || []"
                row-class-name="tableRow">
        <el-table-column prop="name" label="参考线名"/>
        <el-table-column prop="value" label="参考线值">
          <template v-slot="{ row, $index }">
          <span v-if="row.type === 'dynamic'">
            {{ symbolKind.find(el => el.value === row.valueType).label }}
          </span>
            <span v-else>{{ row.value }}</span>
          </template>
        </el-table-column>
        <!--      <el-table-column label="操作">-->
        <!--        <template #default="scope">-->
        <!--          <el-button link type="primary" size="small" @click="deleteRef(scope)">删除</el-button>-->
        <!--        </template>-->
        <!--      </el-table-column>-->
      </el-table>
      <!--    <el-button style="width: 100%" @click="dialogFormVisible = true" color="#000">新增</el-button>-->
    </div>
  </template>
  <el-form-item label="反转">
    <el-switch v-model="prop.rightAxisInverse" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="辅助线条数">
    <el-input-number v-model="prop.rightAxisMarkLine" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="辅助线名称">
    <div style="display: flex; align-items: center;width: 100%">
      <el-input v-model="prop.rightAxisMarkName" size="small"></el-input>
      <div style="width: 16px;"></div>
      <el-tooltip class="item" effect="dark" content="注:辅助线名称使用英文,隔开，请保持字数和条数设置一致"
                  placement="top-start">
        <el-icon>
          <QuestionFilled color="#ffffff"/>
        </el-icon>
      </el-tooltip>
    </div>
  </el-form-item>
  <el-form-item label="辅助线值">
    <div style="display: flex; align-items: center;width: 100%">
      <el-input v-model="prop.rightAxisMarkValue" size="small"></el-input>
      <div style="width: 16px;"></div>
      <el-tooltip class="item" effect="dark" content="注:辅助线值使用英文,隔开，请保持字数和条数设置一致"
                  placement="top-start">
        <el-icon>
          <QuestionFilled color="#ffffff"/>
        </el-icon>
      </el-tooltip>
    </div>
  </el-form-item>
  <el-dialog v-model="dialogFormVisible" title="参考线配置" width="840">
    <RefSet isSub ref="refSet" v-if="dialogFormVisible" :main="main"></RefSet>
    <template #footer>
      <span class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="save">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script setup>
import {Edit, QuestionFilled} from "@element-plus/icons-vue";
import colorPicker from "./color-picker.vue";
import {ref} from "vue";
import RefSet from "@/option/components/commonSet/referenceCustomSet.vue";

const dialogFormVisible = ref(false)
const referenceLines = ref([])
const newReferenceLines = ref({name: '', value: ''})
let props = defineProps({
  prop: {},
  main: {},
});

function closeYName() {
  if (!props.prop.showrightAxisName) {
    props.prop.rightAxisName = ''
  }
}

const refSet = ref()
const symbolKind = [
  {label: "平均值", value: "avg"},
  {label: "最大值", value: "max"},
  {
    label: "最小值",
    value: "min"
  },
  {label: "中位数", value: "mid"}]

const save = () => {
  if (props.isSub) {
    props.main.activeOption.rightReferenceCustomSet = refSet.value.getSetting()
  }
  dialogFormVisible.value = false
  // props.prop.yAxisMarkLineValue = referenceLines.value.map((i) => {
  //   return {yAxis: i.value, label: {formatter: () => i.name}}
  // })
}

function openReference() {
  dialogFormVisible.value = true
}
</script>
<style scoped>
.checkboxAndNumber {
  display: flex;
  align-items: center;
}
</style>